<div class="chips-list">
	@for (chipsItem of chips; track chipsItem) {
		<span
			[class.active]="chipsHasActiveClass(chipsItem)"
			class="chips-item"
			(click)="onChipsClick(chipsItem)"
		>
			{{ chipsItem.name }}
		</span>
	}
</div>
